export default __webpack_public_path__ + "static/assets/193de4fa101e7ba67aeaf3166d726b6a.png";